import styles from '../components/map-styles'

let activeInfoWindow = null

const FitBounds = (map, locationsData, bounds) => {
  if (locationsData.length === 1) {
    map.setCenter(new google.maps.LatLng(locationsData[0].lat, locationsData[0].lng))
    map.setZoom(13)

    return
  }

  map.fitBounds(bounds)
}
const AddMarker = (map, location) => {
  const marker = new google.maps.Marker({
    map: map,
    icon: {
      url: (location.ico) ? `/dist/img/default/${location.ico}` : '/dist/img/default/pin.png',
      scaledSize: new google.maps.Size(30, 30)
    },
    position: new google.maps.LatLng(location.lat, location.lng),
    title: location.name
  })

  const infoWindow = new google.maps.InfoWindow({
    content: `<p class="x:fs-14 ff-body fw-medium txt-uppercase x:center">${location.name}

    <a href="http://maps.google.com/maps?f=d&daddr=${location.lat},${location.lng}" target="_blank"><span class="dis-inline-block x:middle">Indicaciones</span> <i class="fas fa-directions x:fs-16 x:mrg-left-5 dis-inline-block x:middle"></i></a></p>`
  })

  marker.addListener('click', () => {
    if (activeInfoWindow) activeInfoWindow.close()

    infoWindow.open(map, marker)
    activeInfoWindow = infoWindow
  })

  marker.addListener('dblclick', () => {
    map.setCenter(new google.maps.LatLng(location.lat, location.lng))
    map.setZoom(16)
  })
}
const SetMap = (mapContainer) => {
  const locationsData = JSON.parse(mapContainer.getAttribute('locations'))
  let   bounds = new google.maps.LatLngBounds()
  const latLngDefault = new google.maps.LatLng(19.432608, -99.133209)

  const map = new google.maps.Map(mapContainer, {
    center: latLngDefault,
    disableDefaultUI: true,
    zoom: 15,
    zoomControl: true,
    styles: styles
  })

  locationsData.forEach((location, i) => {
    bounds.extend(new google.maps.LatLng(location.lat, location.lng))
    AddMarker(map, location)
  })

  FitBounds(map, locationsData, bounds)
}

const LocationsMap = () => {
  const mapContainer = document.querySelector('#locations-map')

  if (!mapContainer) return

  window.addEventListener('load', () => {
    SetMap(mapContainer)
  })
}

export default LocationsMap
